<template>
  <va-card id="hearing-training-levels-card" :class="{'closed': !expanded}">
    <template slot="header">
      <div class="d-flex align-items-center justify-content-between w-100">
        <h5 class="card-title">{{ $t('accounts.hearing_training_levels') }}</h5>
        <span v-if="expandable" @click.prevent="expanded = !expanded">
          <va-icon class="clickable" :name="expandIconClass" color="success"/>
        </span>
      </div>
    </template>

    <div v-show="expanded">
      <div v-if="levels !== null && levels.some(level => !level.$isDisabled)" class="va-card-body">
        <div class="d-flex fljex-column flex-sm-row justify-content-start align-items-sm-center align-items-start">
          <label class="is-bold">{{$t('accounts.select_level')}}:</label>
          <multiselect
            class="levelsMultiselect"
            v-model="selectedLevel"
            :options="levels"
            track-by="identifier"
            :customLabel="levelMultiselectLabel"
            select-label=""
            placeholder="---"
            :searchable="false"
            :allow-empty="false"
            :multiple="false"
          >
            <template slot="noResult">
              {{$t('multiselect.no_results')}}
            </template>
          </multiselect>
        </div>

        <div v-if="selectedLevel">
          <hearing-training-level-chart
            :results="selectedLevel.results"
            :key="selectedLevel.identifier"
          >
          </hearing-training-level-chart>
        </div>
      </div>
      <div v-else>
        <label>{{$t('accounts.no_hearing_training_attemps')}}</label>
      </div>
    </div>
  </va-card>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { AccountService } from '@/api/AuthClinicalService'
import HearingTrainingLevelChart from './HearingTrainingLevelChart'
import CurrentLocaleMixin from '@/mixins/CurrentLocaleMixin'
const availableLevels = 10
export default {
  props: {
    account: {
      type: Object,
      required: true
    },
    expandable: {
      type: Boolean,
      required: false,
      default: true
    },
    service: {
      type: Object,
      required: true
    }
  },
  components: {
    HearingTrainingLevelChart,
    Multiselect
  },
  mixins: [
    CurrentLocaleMixin
  ],
  computed: {
    expandIconClass: function () {
      return this.expanded ? 'fa fa-chevron-up' : 'fa fa-chevron-down'
    }
  },
  data: function () {
    return {
      expanded: true,
      selectedLevel: null,
      levels: null
    }
  },
  created: function () {
    this.loadHearingTrainingLevels()
  },
  methods: {
    loadHearingTrainingLevels: function () {
      AccountService
        .getHearingTrainingLevels(this.service.url, this.account.id)
        .then(hearingTrainingLevels => {
          this.levels = this.prepareHearingTrainingLevelResults(hearingTrainingLevels)
          this.selectedLevel = this.levels.find(level => !level.$isDisabled) || null
        })
    },
    prepareHearingTrainingLevelResults: function (results) {
      let levels = []
      for (let identifier = 1; identifier <= availableLevels; identifier++) {
        let levelResults = results
          .filter(result => result.identifier === identifier)
          .map(result => {
            return {
              ...result,
              completed_at: this.moment(result.completed_at, 'YYYY-MM-DD HH:mm:ss').locale(this.locale).format('D MMM, LT')
            }
          })
        levels.push({
          identifier,
          results: levelResults,
          $isDisabled: levelResults.length === 0
        })
      }
      return levels
    },
    levelMultiselectLabel: function (level) {
      let label = `${this.$t('accounts.level')} ${level.identifier}`
      if (level.$isDisabled) {
        label = `${label} (${this.$t('accounts.no_hearing_training_attemps')})`
      }
      return label
    }
  }
}
</script>
<style lang="scss" scoped>
.va-card-body {
  min-height: 450px;
}

.levelsMultiselect {
  width: 100%;
  margin-top: 0.5rem;
  margin-left: 0rem;
}

@media (min-width: 768px) {
  .levelsMultiselect {
    width: 25%;
    margin-left: 1rem;
  }
}

</style>
